/* eslint-disable no-restricted-globals */
/* eslint-disable default-case */
import {
    Stack,
    TextField,
    useTheme,
    Button,
    Container,
    Typography,
    Paper,
    Grid,
    Dialog,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    IconButton,
    DialogTitle,
    DialogActions,
    Snackbar,
    Alert,
    LinearProgress,
    FormControlLabel,
    FormLabel,
    RadioGroup,
    Radio,
    FormControl,
    Autocomplete,
    Chip,
    Select,
    MenuItem,
    InputLabel
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import FilterListIcon from '@mui/icons-material/FilterList';
import { set } from 'lodash';
import axios from '../../axiosConfig';
import './animation.css';


// table header cell styles
const StyledTableCell = styled(TableCell)({
    color: '#424242',
    fontWeight: '600',
    // textAlign: 'center',
});

const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

// Generate years array from 1990 to current year + 1 (to include current year)
const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 1990 + 2 }, (_, i) => 1990 + i);

const FactoryExpense = () => {
    const [tokent, settokent] = useState(
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
    );
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const [open, setOpen] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    // handle snackbar & alert messages on save
    const [openAlert, setopenAlert] = useState(false);
    // At the beginning of the component
    const [openDelete, setOpenDelete] = useState(false);
    const [stateIdToDelete, setStateIdToDelete] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    
    // ADD FILTER STATES
    const [filterMonth, setFilterMonth] = useState('all');
    const [filterYear, setFilterYear] = useState('all');
    const [filterProductionUnit, setFilterProductionUnit] = useState('all');
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    //   const [AmountPerMonth, setAmountPerMonth] = useState('');
    const [AmountPerMonth, setAmountPerMonth] = useState('');
    const [CostPerMinute, setCostPerMinute] = useState('')
    const [Active, setActive] = useState('Y');
    const [factorySmvData, setfactorySmvData] = useState([]);
    const [selectedCostDesc, setSelectedCostDesc] = useState(null);

    const [operation, setOperation] = useState('Add');
    const [editID, setEditID] = useState();
    const [errors, setErrors] = useState({
        AmountPerMonth: false,
        Active: false,
        Month: false,
        Year: false,
        ProductionUnit: false,
        CostDescription: false,
        CostPerMinute: false
    });
    const [helperTexts, setHelperTexts] = useState({
        AmountPerMonth: '',
        Active: '',
        Month: '',
        Year: '',
        ProductionUnit: '',
        CostDescription: '',
        CostPerMinute: ''
    });
    // alert messages on operations
    const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
    const [alertMessage, setAlertMessage] = useState('');

    const [openLoader, setOpenLoader] = useState(false);
    const [Month, setMonth] = useState(new Date().getMonth() + 1);
    const [Year, setYear] = useState(new Date().getFullYear());
    const [productionUnits, setProductionUnits] = useState([]);
    const [selectedProductionUnit, setSelectedProductionUnit] = useState([]);

    // API Integration
    useEffect(() => {
        GetDesignationData();
        GetAllFActorySmvData();
        // Fetch production units from API
        fetchProductionUnits();
    }, []);

    // Fetch production units
    const fetchProductionUnits = async () => {
        try {
            const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
            });
            setProductionUnits(res.data);
        } catch (error) {
            console.error('Error fetching production units:', error);
        }
    };

    // get all states Request
    const GetDesignationData = async () => {
        setOpenLoader(true);
        try {
            const res = await axios.instance.get('/GetAllFactoryExpenseData', {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
                
            });
            setFilteredData(res.data); // Initialize filteredData with all data
            console.log(res.data);
            setOpenLoader(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getFilteredFactoryExpenseData = async () => {
    setIsLoading(true);
    try {
        const response = await axios.instance.post('/GetFilteredFactoryExpenseData', 
        { Month: filterMonth ==='all' ? 0 : filterMonth, 
          YEAR: filterYear === 'all' ? 0 : filterYear, 
          Factory_Unit: filterProductionUnit === 'all' ? 0 : filterProductionUnit }, {
            headers: { 
                Authorization: tokent, 
                'Content-Type': 'application/json' 
            },
        });
        setFilteredData(response.data);
    } catch (error) {
        console.error('Error fetching filtered data:', error);
        throw error;
    } finally {
        setIsLoading(false);
    }
}

    // NEW: Reset filters and load all data
    const handleResetFilters = async () => {
        setIsLoading(true);
        setFilterMonth('all');
        setFilterYear('all');
        setFilterProductionUnit('all');
        setIsFilterApplied(false);
        setSearchTerm('');
        
        try {
            // Fetch all data again
            const res = await axios.instance.get('/GetAllFactoryExpenseData', {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
            });
            setFilteredData(res.data);
            setPage(0);
            setAlertType('info');
            setAlertMessage('Filters reset successfully!');
            setopenAlert(true);
        } catch (error) {
            console.error('Error resetting filters:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // post Request to Add state
    const AddGarmentTypeData = async (newState) => {
        try {
            const res = await axios.instance.post('/InsertfactoryExpenseData', newState, {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
            });
            GetDesignationData(); // Refresh data
                  setFilterMonth('all');
        setFilterYear('all');
        setFilterProductionUnit('all');
            setAlertType('success');
            setAlertMessage(' Added Successfully!');
            setopenAlert(true);
        } catch (error) {
            console.error('Error adding state:', error);
            setAlertType('error');
            setAlertMessage('Failed to add the state.');
            setopenAlert(true);
        }
    };

    // put Request to edit state
    const updateState = async (stateId, updatedState) => {
        try {
            await axios.instance.post(`/InsertfactoryExpenseData`, updatedState, {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
            });
            setopenAlert(true);
            setEditID();
            GetDesignationData(); // Refresh data
                  setFilterMonth('all');
        setFilterYear('all');
        setFilterProductionUnit('all');
            setAlertType('success');
            setAlertMessage(' Updated  Successfully!');
            setopenAlert(true);
        } catch (error) {
            console.error('Error updating state:', error);
            setAlertType('error');
            setAlertMessage('Failed to update the state.');
            setopenAlert(true);
        }
    };

    // delete Request to delete state
    const deleteState = async (stateId) => {
        try {
            await axios.instance
                .delete(`/DeletefactoryExpenseData/${stateId}`, {
                    headers: { Authorization: tokent, 'Content-Type': 'application/json' },
                })
                .then((res) => {
                    if (res.data === '') {
                        GetDesignationData(); // Refresh data
                              setFilterMonth('all');
                            setFilterYear('all');
                            setFilterProductionUnit('all');
                        setOpenDelete(false);
                        setAlertType('warning');
                        setAlertMessage(' Deleted Successfully!');
                        setopenAlert(true);
                    } else {
                        GetDesignationData();
                        setOpenDelete(false);
                        setAlertType('error');
                        setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
                        setopenAlert(true);
                    }
                    console.log(res.data);
                });
        } catch (error) {
            console.error('Error deleting state:', error);
            setAlertType('error');
            setAlertMessage('Failed to delete .');
            setopenAlert(true);
        }
    };

    // submit button on add or edit
    const handleSubmit = (event) => {
        event.preventDefault();

        // Validate all required fields
        let hasErrors = false;

        if (!selectedCostDesc) {
            setErrors((prevErrors) => ({ ...prevErrors, CostDescription: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                CostDescription: 'Please Select Cost Description',
            }));
            hasErrors = true;
        }

        if (!AmountPerMonth) {
            setErrors((prevErrors) => ({ ...prevErrors, AmountPerMonth: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                AmountPerMonth: 'please enter Amount/Month',
            }));
            hasErrors = true;
        }

        if (!CostPerMinute) {
            setErrors((prevErrors) => ({ ...prevErrors, CostPerMinute: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                CostPerMinute: 'please enter Cost/Minute',
            }));
            hasErrors = true;
        }

        if (!selectedProductionUnit) {
            setErrors((prevErrors) => ({ ...prevErrors, ProductionUnit: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                ProductionUnit: 'Please Select Factory Unit',
            }));
            hasErrors = true;
        }

        if (!Month) {
            setErrors((prevErrors) => ({ ...prevErrors, Month: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                Month: 'Please Select Month',
            }));
            hasErrors = true;
        }

        if (!Year) {
            setErrors((prevErrors) => ({ ...prevErrors, Year: true }));
            setHelperTexts((prevHelperTexts) => ({
                ...prevHelperTexts,
                Year: 'Please Select Year',
            }));
            hasErrors = true;
        }

        if (hasErrors || 
            errors.AmountPerMonth || 
            errors.CostPerMinute || 
            errors.CostDescription || 
            errors.ProductionUnit || 
            errors.Month || 
            errors.Year) {
            setIsFormSubmitted(true);
            return;
        }

        const newState = {
            optype: operation === 'Edit' ? 'Edit' : 'New',
            AmountPerMonth,
            CostPerMinute,
            CostId: selectedCostDesc.CostId,
            Month,
            Year,
            Factory_Unit: selectedProductionUnit?.Unit_Id || '',
            // Active,
            CreatedBy: sessionStorage.getItem('UserID'),
        };

        const editState = {
            optype: operation === 'Edit' ? 'Edit' : 'New',
            ExpenseId: editID,
            AmountPerMonth,
            CostPerMinute,
            CostId: selectedCostDesc.CostId,
            Month,
            Year,
            Factory_Unit: selectedProductionUnit?.Unit_Id || '',
            // Active,
            ModifyedBy: sessionStorage.getItem('UserID'),
        };

        if (operation === 'Add') {
            AddGarmentTypeData(newState);
        } else if (operation === 'Edit') {
            console.log(editID, editState);
            updateState(editID, editState);
        }
        setAmountPerMonth('');
        handleClose();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const numericFields = ['AmountPerMonth', 'CostPerMinute'];
        
        // Allow decimal numbers for AmountPerMonth and CostPerMinute
        if (numericFields.includes(name) && !/^\d*\.?\d*$/.test(value) && value !== '') {
            return;
        }
        
        switch (name) {
            case 'AmountPerMonth':
                setAmountPerMonth(value);
                // Calculate cost per minute dynamically
                if (value && !isNaN(value)) {
                    const calculatedCost = parseFloat(value) / 12480; // 26 working days × 8 hours × 60 minutes = 12480 minutes
                    setCostPerMinute(calculatedCost.toFixed(4)); // Keep 4 decimal places
                } else {
                    setCostPerMinute('');
                }
                break;
                
            case 'Month':
                setMonth(value);
                break;
                
            case 'Year':
                setYear(value);
                break;
                
            case 'CostPerMinute':
                // Allow manual override
                setCostPerMinute(value);
                break;
                
            default:
                break;
        }
        
        validateInput(name, value);
    };

    // ADD FILTER HANDLERS
    const handleFilterMonthChange = (event) => {
        setFilterMonth(event.target.value);
        setFilteredData([]);
        setIsFilterApplied(false); // Reset filter applied state
    };

    const handleFilterYearChange = (event) => {
        setFilterYear(event.target.value);
        setFilteredData([]);
        setIsFilterApplied(false); // Reset filter applied state
    };

    const handleFilterProductionUnitChange = (event) => {
        setFilterProductionUnit(event.target.value);
        setFilteredData([]);
        setIsFilterApplied(false); // Reset filter applied state
    };

    // NEW: Client-side search filter (for searchTerm only)
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setPage(0); // Reset to first page when search changes
    };

    // Client-side search filter function
    const applyClientSideSearch = () => {
        if (!searchTerm) return filteredData;
        
        return filteredData.filter((c) => {
            return c.CostDescription?.toLowerCase().includes(searchTerm.toLowerCase()) || false;
        });
    };

    // Apply client-side search
    const displayedData = applyClientSideSearch();

    // validations
    const validateInput = (name, value) => {
        let error = false;
        let helperText = '';

        switch (name) {
            case 'CostDescription':
                if (!value || !value.trim()) {
                    error = true;
                    helperText = 'Cost Description cannot be empty';
                    setIsFormSubmitted(false);
                }
                break;
                
            case 'AmountPerMonth':
                if (!value || value.trim() === '') {
                    error = true;
                    helperText = 'Amount/Month cannot be empty';
                    setIsFormSubmitted(false);
                } else if (isNaN(value)) {
                    error = true;
                    helperText = 'Amount/Month must be a number';
                    setIsFormSubmitted(false);
                }
                break;
                
            case 'CostPerMinute':
                if (!value || value.trim() === '') {
                    error = true;
                    helperText = 'Cost/Minute cannot be empty';
                    setIsFormSubmitted(false);
                } else if (isNaN(value)) {
                    error = true;
                    helperText = 'Cost/Minute must be a number';
                    setIsFormSubmitted(false);
                }
                break;
                
            case 'Month':
                if (!value) {
                    error = true;
                    helperText = 'Month is required';
                    setIsFormSubmitted(false);
                }
                break;
                
            case 'Year':
                if (!value) {
                    error = true;
                    helperText = 'Year is required';
                    setIsFormSubmitted(false);
                }
                break;
                
            case 'ProductionUnit':
                if (!value) {
                    error = true;
                    helperText = 'Factory Unit is required';
                    setIsFormSubmitted(false);
                }
                break;
        }

        // Update the errors and helperTexts states correctly
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
        setHelperTexts((prevHelperTexts) => ({
            ...prevHelperTexts,
            [name]: helperText,
        }));
    };

    const handleBlur = (event) => {
        const { name, value } = event.target;
        if (value.length > 0) {
            validateInput(name, value);
        }
    };

    // handle edit popup dialog
    const handleAddOpen = () => {
        setOpen(true);
        setOperation('Add');
        setErrors({
            AmountPerMonth: false,
            Active: false,
            Month: false,
            Year: false,
            ProductionUnit: false,
            CostDescription: false,
            CostPerMinute: false
        });
        setHelperTexts({
            AmountPerMonth: '',
            Active: '',
            Month: '',
            Year: '',
            ProductionUnit: '',
            CostDescription: '',
            CostPerMinute: ''
        });
    };

    // handle edit popup dialog
    const handleEdit = (datas) => {
        setEditID(datas.ExpenseId);
        // setActive(datas.Active);
        setAmountPerMonth(datas.AmountPerMonth);
        setCostPerMinute(datas.CostPerMinute);
        setMonth(datas.Month || new Date().getMonth() + 1);
        setYear(datas.Year || new Date().getFullYear());
        
        const selectedCostDesc = factorySmvData.find(
            (item) => item.CostDescription === datas.CostDescription
        );
        setSelectedCostDesc(selectedCostDesc);
        
        // Set production unit if available in data
        if (datas.Factory_Unit) {
            const selectedUnit = productionUnits.find(
                (item) => item.Unit_Id === datas.Factory_Unit
            );
            setSelectedProductionUnit(selectedUnit || null);
        }

        handleEditOpen();
    };
    
    const handleEditOpen = () => {
        setOpen(true);
        setOperation('Edit');
    };

    // handle delete popup dialog
    const handleDelete = (stateId) => {
        setOpenDelete(true);
        setStateIdToDelete(stateId);
    };

    const handleDeleteConfirmed = (stateId) => {
        deleteState(stateId);
    };
    const handleCloseDelete = () => {
        setOpenDelete(false);
        setopenAlert(false);
    };

    const handleCloseAlert = () => {
        setopenAlert(false);
    };

    const handleClose = () => {
        setOpen(false);
        // setActive('Y');
        setAmountPerMonth('');
        setCostPerMinute('');
        setSelectedCostDesc(null);
        setSelectedProductionUnit(null);
        setMonth(new Date().getMonth() + 1);
        setYear(new Date().getFullYear());
        setErrors({
            AmountPerMonth: false,
            Active: false,
            Month: false,
            Year: false,
            ProductionUnit: false,
            CostDescription: false,
            CostPerMinute: false
        });
        setHelperTexts({
            AmountPerMonth: '',
            Active: '',
            Month: '',
            Year: '',
            ProductionUnit: '',
            CostDescription: '',
            CostPerMinute: ''
        });
    };

    const handleInputChangeSelect = (event, newValue) => {
        setSelectedCostDesc(newValue);
        validateInput('CostDescription', newValue?.CostDescription || '');
    };

    const handleProductionUnitChange = (event, newValue) => {
        setSelectedProductionUnit(newValue);
        validateInput('ProductionUnit', newValue?.Unit_Name || '');
    };

    // pagination
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, displayedData.length - page * rowsPerPage);
    const totalRows = displayedData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    
    // Reset page to 0 when searchTerm changes
    useEffect(() => {
        setPage(0);
    }, [searchTerm]);

    // get all Cities Request
    const GetAllFActorySmvData = async () => {
        setOpenLoader(true);
        try {
            const res = await axios.instance.get('/GetAllFactorySmvData', {
                headers: { Authorization: tokent, 'Content-Type': 'application/json' },
            });
            setfactorySmvData(res.data);
            setOpenLoader(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <>
            <Snackbar
                style={{ marginTop: '45px' }}
                open={openAlert}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
            >
                <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>

            <Container maxWidth={'xl'} elevation={3}>
                <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
                    <Typography
                        variant="h5"
                        p={1}
                        boxShadow={1}
                        borderColor="#11235A"
                        textAlign={'center'}
                        borderRadius={2}
                        pl={2}
                        color="white"
                        sx={{
                            background: 'linear-gradient(to right, #314755, #26a0da)',
                            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                        }}
                    >
                        <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                            Factory Expense Master
                        </Typography>
                    </Typography>
                </Grid>
                
                {/* ADD FILTER SECTION */}
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
    <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
            <Typography variant="subtitle1" fontWeight="bold">
                Filters:
            </Typography>
        </Grid>
        
        {/* Filter Controls */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small">
                <InputLabel>Month</InputLabel>
                <Select
                    value={filterMonth}
                    label="Month"
                    onChange={handleFilterMonthChange}
                >
                    <MenuItem value="all">All Months</MenuItem>
                    {months.map((month, index) => (
                        <MenuItem key={index} value={index + 1}>
                            {month}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small">
                <InputLabel>Year</InputLabel>
                <Select
                    value={filterYear}
                    label="Year"
                    onChange={handleFilterYearChange}
                >
                    <MenuItem value="all">All Years</MenuItem>
                    {years.map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth size="small">
                <InputLabel>Factory Unit</InputLabel>
                <Select
                    value={filterProductionUnit}
                    label="Factory Unit"
                    onChange={handleFilterProductionUnitChange}
                >
                    <MenuItem value="all">All Units</MenuItem>
                    {productionUnits.map((unit) => (
                        <MenuItem key={unit.Unit_Id} value={unit.Unit_Id}>
                            {unit.Unit_Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={6} sm={3} md={2} lg={1}>
            <Button 
                variant="contained" 
                size="small" 
                onClick={getFilteredFactoryExpenseData}
                startIcon={<FilterListIcon />}
                // disabled={isLoading || (filterMonth === 'all' && filterYear === 'all' && filterProductionUnit === 'all' && !searchTerm)}
                fullWidth
            >
                {isLoading ? 'Loading...' : 'View'}
            </Button>
        </Grid>

        <Grid item xs={6} sm={3} md={2} lg={1}>
            <Button 
                variant="outlined" 
                size="small" 
                onClick={handleResetFilters}
                disabled={isLoading}
                fullWidth
            >
                Reset
            </Button>
        </Grid>

        <Grid item xs={12} sm={6} md={2} lg={1}>
            {isFilterApplied && (
                <Chip 
                    label="Filter Applied" 
                    color="primary" 
                    size="small"
                    variant="outlined"
                    sx={{ width: '100%', justifyContent: 'center' }}
                />
            )}
        </Grid>

        {/* Search and Add Button Row */}
        <Grid item xs={12} md={8} lg={6}>
            <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search Cost Description"
                size="small"
                onChange={handleSearchChange}
                value={searchTerm}
                fullWidth
            />
        </Grid>

        <Grid item xs={12} md={4} lg={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Button
                variant="outlined"
                color="secondary"
                sx={{ boxShadow: 1 }}
                onClick={handleAddOpen}
                startIcon={<AddLocationAltRoundedIcon />}
            >
                Add Factory Expense
            </Button>
        </Grid>
    </Grid>
</Paper>

                {/* Loading indicator */}
                {isLoading && (
                    <LinearProgress sx={{ mb: 2 }} />
                )}

                {/* table  */}
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center">S.No</StyledTableCell>
                                <StyledTableCell align="left">Cost Description</StyledTableCell>
                                <StyledTableCell align="left">Month</StyledTableCell>
                                <StyledTableCell align="left">Year</StyledTableCell>
                                <StyledTableCell align="left">Factory Unit</StyledTableCell>
                                <StyledTableCell align="right">Amount/Month</StyledTableCell>
                                <StyledTableCell align="right">Cost/Minutes</StyledTableCell>
                                <StyledTableCell align="center">Actions</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? displayedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : displayedData
                            ).map((state, index) => (
                                <TableRow key={state.DesignationId} hover>
                                    <TableCell align="center">{state.SNo || index + 1}</TableCell>
                                    <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                                        {state.CostDescription}
                                    </TableCell>
                                    <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                                        {state.Month ? months[state.Month - 1] : '-'}
                                    </TableCell>
                                    <TableCell align="left">
                                        {state.YEAR || state.Year || '-'}
                                    </TableCell>
                                    <TableCell align="left">
                                        {state.Factory_Unit_Name || '-'}
                                    </TableCell>
                                    <TableCell align="right" sx={{ textTransform: 'capitalize' }}>
                                        {state.AmountPerMonth}
                                    </TableCell>
                                    <TableCell align="right" sx={{ textTransform: 'capitalize' }}>
                                        {state.CostPerMinute}
                                    </TableCell>
                                    <TableCell align="center" sx={{ padding: '0' }}>
                                        <IconButton aria-label="Edit" onClick={() => handleEdit(state)}>
                                            <EditIcon color="primary" />
                                        </IconButton>
                                        <IconButton aria-label="Delete" onClick={() => handleDelete(state.ExpenseId)}>
                                            <DeleteForeverIcon color="error" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {displayedData.length === 0 && !isLoading && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        <Typography variant="body1" color="textSecondary" py={3}>
                                            {isFilterApplied 
                                                ? 'No data found with the current filters' 
                                                : 'No data available'}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}

                            {emptyRows > 0 && displayedData.length > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={8} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* pagination */}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={totalRows}
                    rowsPerPage={rowsPerPage}
                    page={currentPage}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                    }}
                    mt={2}
                />
            </Container>

            <Grid m={2}>
                {/* add/edit popup form dialog box */}
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
                    <Container component={Paper} elevation={2} sx={{ py: 2 }}>
                        <form onSubmit={handleSubmit} noValidate>
                            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                                    {operation} Factory Expense
                                </Typography>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>
                            <Stack direction={'column'} spacing={2} p={2}>
                                {/* First Row: Month and Year Dropdowns */}
                                <Stack direction="row" spacing={2}>
                                    {/* Month Dropdown */}
                                    <FormControl size="small" fullWidth error={errors.Month}>
                                        <InputLabel>Month</InputLabel>
                                        <Select
                                            name="Month"
                                            value={Month}
                                            label="Month"
                                            onChange={handleInputChange}
                                            required
                                        >
                                            {months.map((month, index) => (
                                                <MenuItem key={index} value={index + 1}>
                                                    {month}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.Month && (
                                            <Typography
                                                variant="caption"
                                                color="error"
                                                className={isFormSubmitted && errors.Month ? 'shake-helper-text' : ''}
                                            >
                                                {helperTexts.Month}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    {/* Year Dropdown */}
                                    <FormControl size="small" fullWidth error={errors.Year}>
                                        <InputLabel>Year</InputLabel>
                                        <Select
                                            name="Year"
                                            value={Year}
                                            label="Year"
                                            onChange={handleInputChange}
                                            required
                                        >
                                            {years.map((year) => (
                                                <MenuItem key={year} value={year}>
                                                    {year}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.Year && (
                                            <Typography
                                                variant="caption"
                                                color="error"
                                                className={isFormSubmitted && errors.Year ? 'shake-helper-text' : ''}
                                            >
                                                {helperTexts.Year}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Stack>

                                {/* Factory Unit Dropdown */}
                                <Autocomplete
                                    size="small"
                                    options={productionUnits}
                                    getOptionLabel={(unit) => unit ? unit.Unit_Name : ''}
                                    value={selectedProductionUnit || null}
                                    onChange={handleProductionUnitChange}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            label="Select Factory Unit" 
                                            required
                                            error={errors.ProductionUnit}
                                            helperText={errors.ProductionUnit ? helperTexts.ProductionUnit : ''}
                                        />
                                    )}
                                />

                                {/* Cost Description Dropdown */}
                                <Autocomplete
                                    size="small"
                                    options={factorySmvData}
                                    getOptionLabel={(cntry) => cntry ? cntry.CostDescription : ''}
                                    value={selectedCostDesc || null}
                                    onChange={handleInputChangeSelect}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            label="Select Cost Description" 
                                            required
                                            error={errors.CostDescription}
                                            helperText={errors.CostDescription ? helperTexts.CostDescription : ''}
                                        />
                                    )}
                                />

                                <TextField
                                    type="text"
                                    variant="outlined"
                                    color="primary"
                                    label="Amount/Month"
                                    name="AmountPerMonth"
                                    value={AmountPerMonth}
                                    onBlur={handleBlur}
                                    onChange={handleInputChange}
                                    fullWidth
                                    required
                                    size="small"
                                    error={errors.AmountPerMonth}
                                    helperText={helperTexts.AmountPerMonth}
                                    className={isFormSubmitted && errors.AmountPerMonth ? 'shake-helper-text' : ''}
                                />

                                <TextField
                                    type="text"
                                    variant="outlined"
                                    color="primary"
                                    label="Cost / Minute"
                                    name="CostPerMinute"
                                    value={CostPerMinute}
                                    onBlur={handleBlur}
                                    onChange={handleInputChange}
                                    fullWidth
                                    required
                                    size="small"
                                    error={errors.CostPerMinute}
                                    helperText={helperTexts.CostPerMinute}
                                    className={isFormSubmitted && errors.CostPerMinute ? 'shake-helper-text' : ''}
                                />

                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    type="submit"
                                    sx={{ textTransform: 'capitalize' }}
                                >
                                    Save
                                </Button>
                            </Stack>
                        </form>
                    </Container>
                </Dialog>

                {/* delete confirmation popup dialog box */}
                <Dialog
                    open={openDelete}
                    onClose={handleCloseDelete}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullScreen={fullScreen}
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle id="alert-dialog-title">{'Are you sure want to Delete?'}</DialogTitle>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={() => handleDeleteConfirmed(stateIdToDelete)} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>

            {/* loader popup dialog box */}
            <Dialog
                open={openLoader}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
            >
                <LinearProgress />
            </Dialog>
        </>
    );
};

export default FactoryExpense;